'use strict';

/* Event
 * 이벤트는 Component 의 mount 단에서 이동하는 event function 들에 대해서
 * 데이터를 담고 있음.
 * 언제 접근할 지 모르므로 함수로 빼놓음. */
const Event = {

};

export default Event;



//////////////////
// WEBPACK FOOTER
// ./js/lib/Event.js
// module id = 414
// module chunks = 0